import React, { useState } from 'react';

function HelpCenter() {
  const [expandedFaq, setExpandedFaq] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');

  const toggleFaq = (id) => {
    setExpandedFaq(expandedFaq === id ? null : id);
  };

  const faqs = [
    {
      id: 1,
      pertanyaan: 'Bagaimana cara mendaftar dan mulai berdonasi?',
      jawaban: 'Klik tombol "Register" di halaman login, isi data diri dengan lengkap, lalu submit. Setelah akun aktif, Anda dapat langsung memilih jenis donasi dan mengikuti instruksi pembayaran yang tersedia.'
    },
    {
      id: 2,
      pertanyaan: 'Apakah data saya aman di aplikasi ini?',
      jawaban: 'Ya. Data pribadi dan transaksi Anda disimpan dengan enkripsi standar, dan hanya digunakan untuk keperluan konfirmasi donasi, laporan, serta komunikasi resmi akun Anda.'
    },
    {
      id: 3,
      pertanyaan: 'Bagaimana cara melakukan donasi melalui aplikasi?',
      jawaban: 'Login lalu pilih menu "Donasi". Pilih program, masukkan nominal, lalu ikuti panduan pembayaran. Setelah selesai, sistem akan menampilkan bukti donasi dan mengirimkan notifikasi.'
    },
    {
      id: 4,
      pertanyaan: 'Bagaimana saya melihat riwayat donasi dan status transaksi?',
      jawaban: 'Buka menu "Riwayat Transaksi" atau "Transaksi". Anda akan melihat daftar donasi, tanggal, jumlah, jenis donasi, dan status pembayaran lengkap.'
    },
    {
      id: 5,
      pertanyaan: 'Apakah ada biaya admin atau biaya tersembunyi?',
      jawaban: 'Semua rincian biaya ditampilkan secara transparan sebelum Anda menyelesaikan pembayaran. Tidak ada biaya tersembunyi selain yang sudah diinformasikan di halaman konfirmasi.'
    },
    {
      id: 6,
      pertanyaan: 'Bagaimana cara mengganti password?',
      jawaban: 'Buka halaman "Profil Saya" dan pilih opsi ubah kata sandi. Masukkan password lama dan buat password baru tanpa perlu verifikasi email tambahan.'
    },
    {
      id: 7,
      pertanyaan: 'Bagaimana cara memperbarui informasi profil saya?',
      jawaban: 'Masuk ke "Profil Saya" lalu klik "Edit Profil". Anda bisa memperbarui nama, alamat, nomor telepon, dan data penting lain; lalu simpan perubahan.'
    },
    {
      id: 8,
      pertanyaan: 'Berapa lama proses donasi sampai terkonfirmasi?',
      jawaban: 'Donasi biasanya diproses dan diverifikasi dalam 1-3 hari kerja. Setelah dikonfirmasi, Anda akan menerima notifikasi dan bukti transaksi resmi dari sistem.'
    }
  ];

  const contactInfo = [
    {
      label: 'WhatsApp / Telepon',
      value: '0823 1900 0200',
      detail: 'Senin - Sabtu: 08:00 - 18:00 WIB'
    },
    {
      label: 'Email Support',
      value: 'support@dtpeduli.org',
      detail: 'Respon dalam 24 jam kerja'
    },
    {
      label: 'Kantor Layanan',
      value: 'Ruko Johar Grande, Jl. Johar Raya No.3, Tanah Sareal, Bogor',
      detail: 'Pusat Operasional'
    },
    {
      label: 'Jam Operasional',
      value: 'Senin - Sabtu',
      detail: '08:00 - 18:00 WIB'
    }
  ];

  const filteredFaqs = faqs.filter(faq =>
    faq.pertanyaan.toLowerCase().includes(searchQuery.toLowerCase()) ||
    faq.jawaban.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="min-h-screen bg-slate-50 text-blue-900 pb-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-8">
        
        {/* Header Hero Banner */}
        <div className="relative overflow-hidden bg-gradient-to-r from-blue-950 via-blue-900 to-blue-900 rounded-3xl p-8 md:p-10 text-white shadow-md border border-blue-900 flex flex-col justify-between gap-4">
          <div className="max-w-3xl space-y-3">
            <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-semibold bg-amber-400/20 text-amber-300 border border-amber-400/30 backdrop-blur-md">
              <span className="w-2 h-2 rounded-full bg-amber-400 animate-pulse"></span>
              MPZ DT • Pusat Bantuan & Support
            </span>
            <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight">Pusat Bantuan</h1>
            <p className="text-xs md:text-sm text-amber-100 leading-relaxed">
              Temukan jawaban cepat mengenai donasi, profil akun, pembayaran, dan panduan penggunaan aplikasi MPZ DT.
            </p>
          </div>
        </div>

        {/* Pencarian FAQ */}
        <div className="bg-white rounded-2xl border border-blue-100 p-4 shadow-sm max-w-2xl mx-auto">
          <div className="flex items-center gap-3">
            <span className="text-slate-400 text-xs font-bold pl-2 uppercase tracking-wider">Cari</span>
            <input
              type="text"
              placeholder="Cari kata kunci pertanyaan (misal: donasi, profil, password)..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-2.5 text-xs text-blue-900 font-medium outline-none focus:bg-white focus:border-blue-600 transition-all"
            />
          </div>
        </div>

        {/* Grid Konten Utama */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">
          
          {/* Kolom Kiri: FAQ (7 Cols) */}
          <div className="lg:col-span-7 space-y-4">
            <div className="flex items-center justify-between pb-2 border-b border-blue-100">
              <h2 className="text-xs font-bold uppercase tracking-wider text-blue-900">Pertanyaan Sering Diajukan (FAQ)</h2>
              <span className="text-[10px] font-semibold bg-blue-50 text-blue-800 px-2.5 py-0.5 rounded-full border border-blue-100">
                {filteredFaqs.length} Topik
              </span>
            </div>

            <div className="space-y-3">
              {filteredFaqs.length === 0 ? (
                <div className="bg-white rounded-2xl border border-blue-100 p-8 text-center text-xs text-slate-500">
                  Tidak ada pertanyaan yang sesuai dengan pencarian Anda.
                </div>
              ) : (
                filteredFaqs.map((faq) => (
                  <div
                    key={faq.id}
                    className="bg-white rounded-2xl border border-blue-100 overflow-hidden shadow-sm hover:border-blue-300 transition-all"
                  >
                    <button
                      onClick={() => toggleFaq(faq.id)}
                      className="w-full px-5 py-4 flex items-center justify-between text-left hover:bg-slate-50/60 transition-colors"
                    >
                      <p className="text-xs font-bold text-blue-900">{faq.pertanyaan}</p>
                      <span className="text-xs font-bold text-blue-600 pl-2">
                        {expandedFaq === faq.id ? '−' : '+'}
                      </span>
                    </button>

                    {expandedFaq === faq.id && (
                      <div className="px-5 py-3.5 bg-blue-50/40 border-t border-blue-100 text-xs text-slate-700 leading-relaxed">
                        {faq.jawaban}
                      </div>
                    )}
                  </div>
                ))
              )}
            </div>
          </div>

          {/* Kolom Kanan: Kontak Resmi (5 Cols) */}
          <div className="lg:col-span-5 space-y-4">
            <div className="flex items-center justify-between pb-2 border-b border-blue-100">
              <h3 className="text-xs font-bold uppercase tracking-wider text-blue-900">Kontak Support Resmi</h3>
            </div>

            <div className="space-y-3">
              {contactInfo.map((contact, idx) => (
                <div key={idx} className="bg-white rounded-2xl border border-blue-100 p-4 shadow-sm space-y-1">
                  <span className="text-[10px] font-bold uppercase tracking-wider text-blue-600">{contact.label}</span>
                  <p className="text-xs font-bold text-blue-900">{contact.value}</p>
                  <p className="text-[11px] text-slate-500">{contact.detail}</p>
                </div>
              ))}
            </div>
          </div>

        </div>

        {/* Footer Support Banner */}
        <div className="bg-white rounded-3xl border border-blue-100 p-6 md:p-8 shadow-sm flex flex-col md:flex-row md:items-center justify-between gap-4">
          <div className="space-y-1">
            <h3 className="text-sm font-bold text-blue-900">Belum Menemukan Jawaban?</h3>
            <p className="text-xs text-slate-600">Tim dukungan pelanggan MPZ DT siap membantu kendala Anda pada jam kerja.</p>
          </div>
          <div className="flex flex-wrap gap-2 text-xs font-bold">
            <span className="px-3 py-1.5 rounded-xl bg-blue-50 text-blue-900 border border-blue-200">Email: support@dtpeduli.org</span>
            <span className="px-3 py-1.5 rounded-xl bg-amber-100 text-amber-900 border border-amber-200">WA: 0823 1900 0200</span>
          </div>
        </div>

      </div>
    </div>
  );
}

export default HelpCenter;
